// extracted by css-extract-rspack-plugin
module.exports =  {"candidateResultStatusWrap":"Scmet","pipe":"jDf5A","statusCap":"P0Pm4","leading":"F1Jcj","trailing":"RocA3","won":"c77Jz","lost":"xf7Ho"};